<template>
<div class="cambook-layout">
  <layout-header />
  <div class="cambook-container flex items-start justify-between">
    <sidebar />
    <div class="cambook-view">
      <router-view />
    </div>
  </div>
  <layout-footer />
</div>
</template>
<script>
import { defineComponent } from 'vue'
import LayoutHeader from '@/layout/components/Header.vue'
import LayoutFooter from '@/layout/components/Footer.vue'
import Sidebar from '@/layout/components/Sidebar.vue'
import useUserStore from '@/stores/User.js'
import { useSchoolStore } from '@/stores/School.js'
import { getBookList } from '@/api/home/index.js'
import useHomeStore from '@/stores/Home'
export default defineComponent({
  name: 'LayoutContainer',
  components: {
    LayoutHeader,
    LayoutFooter,
    Sidebar,
  },
  data() {
    return {
      timer: null,
      loaded: false,
    }
  },
  async created() {
    try {
      const result = await getBookList({
        keyword: '',
        pageNum: 1,
        pageSize: 1000,
      })

      if (result?.rows) {
        const rowValues = result?.rows || []

        useHomeStore().updateBookCursors(rowValues)
        useHomeStore().updateBookCursorsForStorage()
      }
    } catch (e) {
      console.log(e, 'layout loaded error')
    }

    this.loaded = true
  },
  async mounted() {
    // 动态设置cambook-sidebar的高度
    const userStore = useUserStore()
    const schoolStore = useSchoolStore()

    await userStore.GetStudentInfo({
      code: 200,
      roles: userStore.UserRoles,
      user: userStore.userInfo,
    })
    // 兜底：确保侧边栏 / 空书架 Redeem 入口能拿到学校配置
    if (!schoolStore.configLoaded) {
      await schoolStore.fetchSchoolConfig()
    }
    await userStore.GetReadHistoryList()
    window.addEventListener('message', this.getPostMessage, false)

    window.addEventListener('visibilitychange', this.updateHistoryByStorage)

    // this.timer = setInterval(() => {
    //   userStore.GetReadHistoryList()
    // }, 3000)
  },
  methods: {
    async updateHistory(event) {
      if (event.key === 'CAN_BOOM_STATE') {
        const userStore = useUserStore()

        await userStore.GetReadHistoryList()
      }
    },
    async updateHistoryByStorage() {
      if (document.visibilityState !== 'hidden') {
        const userStore = useUserStore()

        await userStore.GetReadHistoryList()
      }
    },
    getPostMessage(evt) {
      // console.log(evt, 'getPostMessage')
      if (evt?.data?.eventKey === 'pageUpdate') {
        const userStore = useUserStore()

        userStore.GetReadHistoryList()
      }
    },
  },
  async unmounted() {
    window.removeEventListener('message', this.getPostMessage, false)
    window.removeEventListener('visibilitychange', this.updateHistoryByStorage)
  },
})
</script>
<style scoped lang="scss">
@import "@/assets/styles/mixin";
.cambook-layout {
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.cambook-container {
  @include baseWidth();
  min-height: 100%;
  padding-top: 84px;
  padding-bottom: 40px;
  box-sizing: border-box;
  .cambook-view {
    flex: 1;
    width: calc(100% - 200px);
    margin-left: 120px;
    height: 100%;
    @media screen and (max-width: 1200px) {
      margin-left: 40px;
    }
  }
}
</style>
